import { jsx as _jsx } from "react/jsx-runtime";
import FeaturedItemBlockComponent, {} from '../../../featureditem';
const FeaturedItemBlock = ({ value }) => _jsx(FeaturedItemBlockComponent, { ...value });
export default FeaturedItemBlock;
